<template>
  <div
    class="fts-collapsible-element"
    :class="[
      isVisible ? expandClass : collapseClass,
      {'collapsible-element--comfort': comfortDesign}
    ]"
  >
    <slot 
      name="toggle" 
      :toggle="toggle" 
      :isVisible="isVisible" 
      v-if="immersive ? !isVisible : true"
    >
      <div
        key="style-1"
        class="collapsible-element-toggle collapsible-element-toggle--style-1"
        :class="[{'collapsible-element-toggle--expand': isVisible}, toggleClass]"
        v-if="variant == 'style-1'"
      >
        <div class="collapsible-element-toggle-wrapper" @click="toggle">
          <div class="collapsible-element-toggle-icon">
            <font-awesome-icon :icon="['fas', 'caret-right']" />
          </div>
          <div>
            <div class="collapsible-element-toggle-label">
              {{label}}
            </div>
            <div class="collapsible-element-toggle-helper" v-if="!!helper">
              {{helper}}
            </div>
          </div>
        </div>
      </div>

      <div
        key="style-default"
        class="collapsible-element-toggle collapsible-element-toggle--style-default" 
        :class="[{'toggle-mb': !immersive && isVisible}, toggleClass]" 
        @click="toggle"
        v-else
      >
        <slot name="toggle-text" :isVisible="isVisible">
          click to {{isVisible ? 'disable' : 'enable'}} {{label}} 
        </slot>
        <div v-if="beta">
          &nbsp;
          <fts-release-badge class="fts-align-top" />
        </div>
      </div>
    </slot>
    <slot name="content" :isVisible="isVisible" v-if="isVisible">
      Default Content
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    initialVisible: Boolean,
    condition: {
      required: false
    },
    expandClass: String,
    collapseClass: String,
    toggleClass: String,
    immersive: Boolean, // toggle once
    label: {
      type: String,
      default: 'element'
    },
    helper: String,
    variant: String,
    comfortDesign: Boolean,
    beta: Boolean
  },
  model: {
    prop: "condition",
    event: "updateCondition"
  },
  data: () => ({
    isVisible: false,
  }),
  methods: {
    toggle() {
      this.isVisible = !this.isVisible;
      this.$nextTick(() => {
        if (this.isVisible) {
          this.$emit("content:visible");
        } else {
          this.$emit("content:hidden");
        }
      });
      this.$emit("updateCondition", this.isVisible);
    }
  },
  watch: {
    condition: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.immersive || (this.immersive && !oldVal))
          this.isVisible = !!val;
      }
    }
  },
  mounted() {
    this.initialVisible && (this.isVisible = true);
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-collapsible-element {
  .collapsible-element-toggle {
    @include user-select-none;
  }
  .collapsible-element-toggle--style-1 {
    display: flex;
    font-size: $font-size;
    line-height: $line-height;
    color: var(--fts-text);
    .collapsible-element-toggle-wrapper {
      display: flex;
      align-items: flex-start;
      cursor: pointer;
    }
    .collapsible-element-toggle-label {
    }
    .collapsible-element-toggle-helper {
      font-size: $font-size;
      line-height: $line-height;
      color: var(--fts-default);
    }
    .collapsible-element-toggle-icon {
      height: $font-size * $line-height;
      width: $font-size;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.375rem;
      font-size: $font-size;
      svg {
        transition: transform 0.3s;
      }
    }
    &.collapsible-element-toggle--expand {
      margin-bottom: 0.75rem;
      .collapsible-element-toggle-icon {
        svg {
          transform: rotate(90deg);
        }
      }
    }
  }
  .collapsible-element-toggle--style-default {
    display: inline-flex;
    color: var(--fts-default);
    font-size: 0.875rem;
    font-weight: 300;
    &:hover {
      color: var(--fts-primary);
      cursor: pointer;
    }
    &.toggle-mb {
      margin-bottom: 0.75rem;
    }
  }
  &.collapsible-element--comfort {
    .collapsible-element-toggle--style-1 {
      font-size: $comfort-font-size;
      line-height: $comfort-line-height;
      .collapsible-element-toggle-icon {
        height: $comfort-line-height;
      }
      &.collapsible-element-toggle--expand {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>